import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import { Accordion, AccordionItem } from '@bwoty-web/ui-kit';

import './routeContent.scss';

const isAtSea = (day) => {
  return (
    day?.locationName?.toLowerCase() === 'at sea' ||
    day?.locationName?.toLowerCase() === 'cruising'
  );
};

const checkMissingArrivalDeparture = (day) => {
  return day?.arrival?.day !== null && day?.departure?.day !== null;
};

const RouteContent = ({ itinerary, atSeaText, labels }) => {
  if (!itinerary) {
    return null;
  }

  const getHeader = (day) => {
    const routeDayHeaderArray = [];
    if (day?.connectedResortName) {
      routeDayHeaderArray.push(day.connectedResortName);
    }
    if (
      day?.connectedAreaName &&
      day?.connectedAreaName !== day?.connectedResortName
    ) {
      routeDayHeaderArray.push(day.connectedAreaName);
    }
    if (day?.connectedCountryName) {
      routeDayHeaderArray.push(day.connectedCountryName);
    }
    let routeDayHeader = routeDayHeaderArray.join(', ');
    if (!routeDayHeader && isAtSea(day)) {
      routeDayHeader = labels.atSeaText;
    }
    if (day?.arrival?.day === undefined || day?.departure?.day === undefined) {
      return `${labels.dayText} ${
        day?.departure?.day || day?.arrival?.day
      }: ${routeDayHeader}`;
    }
    if (
      day?.arrival?.day !== day?.departure?.day &&
      checkMissingArrivalDeparture(day)
    ) {
      return `${labels.dayText} ${day?.arrival?.day} - ${day?.departure?.day}: ${routeDayHeader}`;
    }
    return `${labels.dayText} ${
      day?.departure?.day || day?.arrival?.day
    }: ${routeDayHeader}`;
  };

  const getSubHeader = (day) => {
    const routeDaySubHeaderArray = [];
    if (!day?.arrival && day?.departure?.day === 1) {
      routeDaySubHeaderArray.push(`${labels.boardingText}`);
    }
    if (day?.arrival?.time) {
      routeDaySubHeaderArray.push(
        `${labels.arrivalText}: ${day?.arrival?.time}`,
      );
    }
    if (day?.departure?.time) {
      routeDaySubHeaderArray.push(
        `${labels.departureText}: ${day?.departure?.time}`,
      );
    }
    return routeDaySubHeaderArray.join(' ');
  };

  return (
    <div>
      <Accordion oneAtATime>
        {itinerary.map((day) => {
          const dayDescription = isAtSea(day) ? atSeaText : day?.description;
          return (
            <AccordionItem
              header={getHeader(day)}
              key={uniqid('gw-cruise-route-pop-up__accordion-')}
              subHeader={getSubHeader(day)}
            >
              {dayDescription && <p>{dayDescription}</p>}
            </AccordionItem>
          );
        })}
      </Accordion>
      <p className="gw-cruise-route-pop-up__footnote">{labels?.footnoteText}</p>
    </div>
  );
};

RouteContent.propTypes = {
  itinerary: PropTypes.arrayOf(
    PropTypes.shape({
      connectedResortName: PropTypes.string,
      connectedAreaName: PropTypes.string,
      connectedCountryName: PropTypes.string,
      description: PropTypes.string,
      departure: PropTypes.shape({
        day: PropTypes.number,
        time: PropTypes.string,
      }),
      arrival: PropTypes.shape({
        day: PropTypes.number,
        time: PropTypes.string,
      }),
    }),
  ).isRequired,
  atSeaText: PropTypes.string.isRequired,
  labels: PropTypes.shape({
    routePopupHeader: PropTypes.string,
    dayText: PropTypes.string,
    arrivalText: PropTypes.string,
    departureText: PropTypes.string,
    boardingText: PropTypes.string,
    atSeaText: PropTypes.string,
    footnoteText: PropTypes.string,
  }).isRequired,
};

export default RouteContent;
